module.exports = __webpack_public_path__ + "img/disc-drive.a81ffda4.svg";